import React from 'react';
import { ExternalLink } from 'lucide-react';

const TermsAndConditions = () => {
  const termsUrl = 'https://vbwaup6y.kartra.com/page/4GU2085';

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="mb-8">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">Terms and Conditions</h1>
            <p className="text-gray-600 text-lg">
              Please review our Terms and Conditions before using ElderFit Secrets.
            </p>
          </div>

          <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-lg mb-8">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0">
                <svg className="h-6 w-6 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-blue-900 mb-2">View Full Terms and Conditions</h3>
                <p className="text-blue-800 mb-4">
                  Our complete Terms and Conditions are hosted on our secure legal page. 
                  Click the button below to view the full document.
                </p>
                <a
                  href={termsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors shadow-md hover:shadow-lg"
                >
                  <span>View Terms and Conditions</span>
                  <ExternalLink className="w-5 h-5" />
                </a>
              </div>
            </div>
          </div>

          <div className="prose prose-lg max-w-none">
            <div className="mb-6 p-4 bg-indigo-50 border-l-4 border-indigo-500 rounded-lg">
              <p className="text-sm text-gray-700">
                <strong>Company:</strong> Pete Murray Ltd (trading as ElderFit Secrets)<br />
                <strong>Trading Name:</strong> ElderFit Secrets
              </p>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">Quick Summary</h2>
            <p className="text-gray-700 mb-6">
              By using ElderFit Secrets (operated by Pete Murray Ltd), you agree to our Terms and Conditions. Here are some key points:
            </p>

            <div className="space-y-6">
              <div className="border-l-4 border-indigo-500 pl-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Medical Disclaimer</h3>
                <p className="text-gray-700">
                  ElderFit Secrets is a fitness and wellness program, NOT a medical service. 
                  You must consult with your healthcare provider before beginning any exercise program, 
                  especially if you are over 50 or have pre-existing health conditions.
                </p>
              </div>

              <div className="border-l-4 border-indigo-500 pl-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Subscription Terms</h3>
                <p className="text-gray-700">
                  Subscriptions automatically renew monthly unless cancelled. You may cancel at any time 
                  through your account settings or by contacting support@elderfitsecrets.com. 
                  Cancellation takes effect at the end of the current billing period.
                </p>
              </div>

              <div className="border-l-4 border-indigo-500 pl-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Refund Policy</h3>
                <p className="text-gray-700">
                  Refund requests must be submitted within 7 days of initial purchase. 
                  EU/UK customers have a 14-day right of withdrawal. 
                  No refunds are provided for the current billing period once payment has been processed.
                </p>
              </div>

              <div className="border-l-4 border-indigo-500 pl-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Content Access</h3>
                <p className="text-gray-700">
                  Upon cancellation, you will lose access to premium/elite content at the end of your 
                  billing period. Free tier content remains accessible. All content is for individual use only.
                </p>
              </div>

              <div className="border-l-4 border-indigo-500 pl-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Liability</h3>
                <p className="text-gray-700">
                  You participate in the program at your own risk. Pete Murray Ltd (trading as ElderFit Secrets) assumes no responsibility 
                  for injuries, health complications, or medical conditions that may arise from participation. 
                  Always consult your healthcare provider before starting any exercise program.
                </p>
              </div>
            </div>

            <div className="mt-8 p-6 bg-gray-50 rounded-lg border border-gray-200">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Questions?</h3>
              <p className="text-gray-700 mb-4">
                If you have questions about our Terms and Conditions, please contact us:
              </p>
              <p className="text-gray-700">
                <strong>Email:</strong>{' '}
                <a 
                  href="mailto:support@elderfitsecrets.com" 
                  className="text-indigo-600 hover:text-indigo-700 underline"
                >
                  support@elderfitsecrets.com
                </a>
              </p>
            </div>

            <div className="mt-8 flex justify-center">
              <a
                href={termsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-8 py-4 bg-indigo-600 text-white font-semibold rounded-lg hover:bg-indigo-700 transition-colors shadow-md hover:shadow-lg text-lg"
              >
                <span>Read Full Terms and Conditions</span>
                <ExternalLink className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;

